const getAppRedirectUrl = (appUrl: string, appToken: string) => {
  if (appUrl.indexOf('?') > -1) {
    return `${appUrl}&token=${appToken}`;
  }
  return `${appUrl}?token=${appToken}`;
};

export default getAppRedirectUrl;
